export const layoutConstants = {
  // 變更側邊選單開關
  COLLAPSED_CHANGE: "LAYOUT_COLLAPSED_CHANGE"
};
